import { render, staticRenderFns } from "./SacPrincipal.vue?vue&type=template&id=24fb7430&"
import script from "./SacPrincipal.vue?vue&type=script&lang=js&"
export * from "./SacPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports